import * as t from 'io-ts';
import { createActions } from 'redux-actions';

import { ENDPOINTS_TEAMS } from '../../config';
import { localeData } from '../../locales/data';
import { TeamOptionsStructure } from '../../reducers/TeamReducer/TeamOptionsReducer/TeamOptionsReducer.types';
import { globalFetch, isAction, webSimApiErrorFlashMessages } from '../../shared/helpers/fetch-helper';
import { logErrorService } from '../../shared/services';
import { addFlashMessages } from '../FlashMessagesActions';

export const { teamOptionsRequest, teamOptionsResponseFailure, teamOptionsResponseSuccess } = createActions(
  {},
  'TEAM_OPTIONS_REQUEST',
  'TEAM_OPTIONS_RESPONSE_FAILURE',
  'TEAM_OPTIONS_RESPONSE_SUCCESS'
);

export const fetchTeamOptions =
  (competitionId: string) =>
  async (dispatch: any): Promise<object> => {
    dispatch(teamOptionsRequest());

    return globalFetch(
      `${ENDPOINTS_TEAMS.teams}/${competitionId}`,
      {
        method: 'OPTIONS',
        headers: new Headers({ 'Content-Type': 'application/json' }),
        credentials: 'include',
      },
      dispatch,
      () => dispatch(teamOptionsResponseFailure())
    )
      .then(async (response: any): Promise<object> => {
        if (isAction(response, 'TEAM_OPTIONS_RESPONSE_FAILURE')) {
          return response;
        } else if (t.exact(TeamOptionsStructure).decode(response).isRight()) {
          return dispatch(teamOptionsResponseSuccess(response.actions.GET));
        } else if (response && response.detail) {
          logErrorService(response, response);
          dispatch(addFlashMessages([{ msg: response.detail, defaultMessage: localeData.en[response.detail] }]));

          return dispatch(teamOptionsResponseFailure());
        } else {
          logErrorService(response, response);
          webSimApiErrorFlashMessages(dispatch);

          return dispatch(teamOptionsResponseFailure());
        }
      })
      .catch((error: any) => {
        logErrorService(error, error);
        webSimApiErrorFlashMessages(dispatch);

        return dispatch(teamOptionsResponseFailure());
      });
  };
